export const changePage = (value1: number, value2: number) => {
  const result = value1 * value2 - value2
  return result.toString()
}
